import { formatTweetText } from '@/lib/utils';

interface TweetContentProps {
  text: string;
}

export function TweetContent({ text }: TweetContentProps) {
  return (
    <div className="tweet-content text-sm leading-relaxed mb-3 whitespace-pre-wrap break-words">
      <span dangerouslySetInnerHTML={{ __html: formatTweetText(text) }} />
    </div>
  );
}
